// Centralized impersonation localStorage management.
//
// Two independent impersonation modes share localStorage keys:
//   - `impersonation` — role-impersonation (any environment).
//   - `impersonate_user` — cross-workspace user-impersonation (prod1
//     only). Picking a user whose effective permissions render the page
//     blank can leave the operator unable to find the EXIT control;
//     centralising clear paths here means every recovery surface
//     (sign-out, sign-in, URL escape hatch, banner button) wipes the
//     same set without drifting.

export const IMPERSONATION_LOCAL_STORAGE_KEYS = ['impersonation', 'impersonate_user'] as const;

export const clearAllImpersonation = (): void => {
  if (typeof window === 'undefined') return;
  IMPERSONATION_LOCAL_STORAGE_KEYS.forEach((key) => {
    window.localStorage.removeItem(key);
  });
};

// URL escape hatch — visit `?exit_impersonation=1` from any page to
// recover from an impersonation that left the UI unrenderable. Runs at
// module-load (called from `_app.tsx`) before React mounts so it works
// even when the auth-gated app body is broken.
export const handleImpersonationEscapeHatch = (): void => {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('exit_impersonation') === '1') {
      clearAllImpersonation();
      // Strip the query so a refresh doesn't keep clearing forever
      // and bury whatever the operator was actually trying to view.
      window.location.replace(window.location.pathname);
    }
  } catch (e) {
    // localStorage / URL APIs throwing here means the browser is
    // misbehaving — log and continue rather than crash the app.
    // eslint-disable-next-line no-console
    console.error('Impersonation escape hatch failed:', e);
  }
};
